export default "/assets/images/pair-your-mila.8ac20057725c2ffe.webp";